import { css } from '@emotion/core';
import { variables, mq } from '../../../cssInJs';

const numberOfTiles = [1, 2, 3, 3]
//const marginLR = [14, 14, 14, 14]
const marginTB = [14, 14, 14, 14]

const widthPercent = (index) => 100 / numberOfTiles[index] + '%'

const linkText = {
  color: variables.fontColor,
  //fontSize: '0.8rem',
  //padding: '0 20px',
  '&:hover': {
    color: variables.fontColor,
  }
}

export const tileListStyle = {
  tiles: mq({
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    //marginLeft: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    //marginRight: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['960px'],
    margin: 'auto'
  }),
  categoryList : mq({
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['960px'],
    margin: 'auto',
    'div.ff.form-group' : {
      maxWidth: '250px'
    }
  })
}

export const tileStyle = {
  tile: mq({
    //paddingLeft: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    //paddingRight: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    paddingLeft : '10px',
    paddingRight : '10px',
    paddingTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    paddingBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexBasis: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexGrow: 0,
    flexShrink: 0
  }),
  discontinuedWaterMark: css({
    backgroundImage: 'url(../../assets/discontinued-watermark.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    width: '100%',
    height: '73%',
    // backgroundColor: 'red',
    zIndex: 1
  }),
  tileLink: {
    background: '#fff',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    //padding: 5,
    //border: '1px solid red',
    '&:hover': {
      textDecoration: 'none'
      //background: '#f3f3f3'
    }
  },
  prdImage: {
    //padding: '0 5px',
    //maxWidth: '190px',
    //margin: 'auto',
    //width: '100%',
    backgroundColor: 'grey',
    position: 'relative'
  },
  bg: {
    //height: 0,
    //paddingBottom: '100%',
    //paddingTop: '78%',
    paddingTop: '100%',
    backgroundPosition: 'center top',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  },
  shortDes : css({
    textAlign:'center',
    color: variables.fontColor,
    fontSize:'0.7rem',
    marginBottom:'0.5rem'
    //marginTop: '0.8rem'
  }),
  name: css(linkText, {
    //fontWeight: 'bold',
    //fontFamily: variables.familyHeader,
    textAlign:'center',
    //marginBottom:'8px',
    fontSize:'1.4rem',
    padding:'0',
    lineHeight:'1.2',
    marginBottom:'0.3rem'
  }),
  price: css(linkText, {
    //marginTop: 'auto',
    textAlign:'center',
    fontSize:'0.75rem',
    fontWeight:700,
    marginBottom:'0.5rem'
    //marginBottom:'1rem'
  }),
  button : css({
    textAlign:'center',
    marginTop : 'auto',
    border:`1px solid ${variables.primaryColor}`,
    fontWeight: 700
  }),
  desContainer : css({
    padding:'1rem 1.2rem',
    display:'flex',
    flexDirection:'column',
    //border:'1px solid red',
    height:'100%'
  })
}